import { ExportColumn } from '../../../../../interfaces/ExportColumn';

export const baseColumnsInbound: ExportColumn[] = [
  {
    key: 'materialTypeName',
    header: 'Material/Type',
    type: 'text',
    width: 50,
  },
  {
    key: 'supplierName',
    header: 'Supplier Name',
    type: 'text',
    placeholder: 'Not Provided',
  },
  {
    key: 'newDestination',
    header: 'New Destination',
    type: 'text',
    placeholder: 'Not Provided',
  },
  {
    key: 'shippingMethod',
    header: 'Shipping Method',
    type: 'text',
    placeholder: 'Not Provided',
  },
  {
    key: 'internalContactFirstName',
    header: 'Internal Contact First Name',
    type: 'text',
    placeholder: 'Not Provided',

    width: 30,
  },
  {
    key: 'internalContactLastName',
    header: 'Internal Contact Last Name',
    type: 'text',
    placeholder: 'Not Provided',

    width: 30,
  },
  {
    key: 'internalEmail',
    header: 'Internal Contact Email',
    type: 'email',
    placeholder: 'Not Provided',
    width: 30,
  },
];

export const baseColumnsOutbound: ExportColumn[] = [
  {
    key: 'materialTypeName',
    header: 'Product/Material',
    type: 'text',
    width: 50,
  },
  {
    key: 'commentary',
    header: 'Commentary',
    type: 'text',
    placeholder: 'Not Provided',
    width: 50,
  },
  {
    key: 'firstName',
    header: 'First Name',
    type: 'text',
    placeholder: 'Not Provided',
    width: 30,
  },
  {
    key: 'lastName',
    header: 'Last Name',
    type: 'text',
    placeholder: 'Not Provided',
    width: 30,
  },
  {
    key: 'email',
    header: 'Email',
    type: 'email',
    placeholder: 'Not Provided',
    width: 30,
  },
];
